<template>
  <SortSearch
    default-sort="trending"
    dimension="TrendingDesigns"
    :force-experience="getMerch"
    query="Y2k"
  />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('experience', ['getMerch'])
  },
  nuxtI18n: {
    paths: {
      en: '/merch/trending-designs',
      es: '/merch/disenos-de-tendencia',
      pt: '/merch/designs-de-tendencia',
      de: '/merch/designs-im-trend'
    }
  }
};
</script>
